define([
	"dojo/_base/declare",
	"csi/heading/Time",
	"csi/xml",
	"./_CompletionRendererMixin"
], function(declare,Time,xml,_CompletionRendererMixin) {

	return declare([Time, _CompletionRendererMixin], {
		toValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: if completion date is empty, then look to completeness
			return this.inherited(arguments) || this._getCalendarValue(ctx, ctx.getNode(), "Completeness");
		},

		_getCalendarValue: function(/*Context*/ctx, /*Node*/rollup, /*String*/id) {
			// summary: return attribute value on activity
			return ctx.hasContainerKey() ? this.inherited(arguments) : xml.nodeGetAttributeValue(ctx.getNode(), id);
		},

		_getMasterActivity: function(/*Context*/ctx, /*Node?*/cal) {
			// summary: return master activity from activity
			return ctx.cache.getNode(ctx.getNode().Master);
		},

		_getRenderCSS: function(/*Context*/ctx, /*Heading*/h) {
			return this._addCompletionCSS(ctx, this.inherited(arguments));
		}
	});
});